// Import plugin.
import React from 'react';
import ReactDOM from 'react-dom';

const Selector = (props) => {
  const SCROLL_CONTAINER_HEIGHT = props.listHeight * props.list.length;
  return(
    <div className="select-btn" data-label={ props.dataContent } data-content={ props.dataContent } onClick={ props.openClose }
    data-text={ props.text } aria-selected={ props.isOpen }>
      <div className="select-btn__selector">
        <div className="select-btn__selector__scroller" 
        style={{ "height": SCROLL_CONTAINER_HEIGHT > 160 ? 160 : SCROLL_CONTAINER_HEIGHT }}>
          <ul>
          {
            props.list.map((x, num) => {
              return <li key={ num } role="button" data-content={ x } 
              onMouseEnter={ props.pickContentName } onMouseLeave={ props.pickContentName } 
              onClick={ props.pickContentName }>{ x }</li>
            })
          }
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Selector;